// @flow

import _ from 'lodash/fp';
import React from 'react';
import Linkify from 'react-linkify';
import {
  productPrice,
  productUnit,
} from '../../helpers/priceHelpers';
import CustomerProductImage from '../CustomerProductImage/CustomerProductImage';
import CustomerProductOrderButton from '../CustomerProductOrderButton/CustomerProductOrderButton';
import FormattedPrice from '../FormattedPrice/FormattedPrice';
import {DEMO} from '../../roles.js';
import './CustomerProductCard.css';

const warningText = 'Ej valbart p.g.a. tidigare val.';

export const getVariantOptions = (activeSelection: any, enabled: boolean, product: any, variant: any) => {
  let variantEnabled = true;
  let isDefault = false;
  let isSelected = false;
  let variantConfig = null;
  let showWarning = !!enabled
    ? false
    : warningText;
  if (!!activeSelection.slot.advanced && !!activeSelection.config) {
    variantConfig = _.find({
      parentId: !!activeSelection.parentConfig
        ? activeSelection.parentConfig.id
        : null,
      productVariantId: variant.id,
    }, activeSelection.config.configs);
    if (!!variantEnabled) {
      variantEnabled = !!variantConfig;
    }
    if (!!enabled && !variantEnabled) {
      showWarning = warningText;
    }
    isDefault = !!activeSelection.parentConfig
      ? _.some({
        productId: product.id,
        productTypeId: activeSelection.config.id,
      }, activeSelection.parentConfig.standardProducts)
      : activeSelection.slot.standardProductId === product.id;
    if (!!variantConfig) {
      isSelected = !!activeSelection.orderRow
        ? activeSelection.orderRow.configId === variantConfig.id
        : false;
    }
  } else {
    isDefault = activeSelection.slot.defaultProductId === product.id;
    isSelected = !!activeSelection.orderRow
      ? activeSelection.orderRow.productVariantId === variant.id
      : false;
  }
  return {
    variantEnabled,
    isDefault,
    isSelected,
    variantConfig,
    showWarning,
  };
};

export type Props = {
  product: Object,
  variant: Object,
  onOpenProduct: Function,
  onSelectProduct: Function,
  onRemoveProduct: Function,
  enabled: boolean,
  variantOptions: Object,
  activeSelection: Object,
  userRole: Number,
};

const CustomerProductCard = ({
  product,
  variant,
  onOpenProduct,
  onSelectProduct,
  onRemoveProduct,
  enabled,
  variantOptions,
  activeSelection,
  userRole,
}: Props) => {
  const {
    variantEnabled,
    isDefault,
    isSelected,
    variantConfig,
    showWarning,
  } = variantOptions;

  return (
    <div className="CustomerProductCard">
      <div className="CustomerProductCard-content">
        <div
          className="CustomerProductCard-info"
          onClick={() => onOpenProduct(product, variant)}>
          <div className="CustomerProductCard-image">
            <CustomerProductImage
              className="fill-container"
              file={_.find({isDefault: true}, variant.images)}
              size="240h" />
            <div className="CustomerProductCard-popup-info">
              Klicka för mer info
            </div>
            {!isSelected &&
              <span className="CustomerProductCard-popup-info-icon">
                <i className="fa fa-info-circle" />
              </span>
            }
          </div>
          <div className="CustomerProductCard-name">
            {product.name} - {variant.name}
          </div>
          <Linkify
            className="CustomerProductCard-description shrink"
            properties={{target: '_blank'}}>
            <p>{variant.externalDescription || product.externalDescription}</p>
          </Linkify>
          <div className="CustomerProductCard-specifications">
            <table>
              <tbody>
                {!_.isEmpty(variant.color) &&
                  <tr>
                    <td>Färg:</td>
                    <td>{variant.color}</td>
                  </tr>
                }
                {!!variant.sizeWidth &&
                  <tr>
                    <td>Bredd:</td>
                    <td>{variant.sizeWidth} cm</td>
                  </tr>
                }
                {!!variant.sizeHeight &&
                  <tr>
                    <td>Höjd:</td>
                    <td>{variant.sizeHeight} cm</td>
                  </tr>
                }
                {!!variant.sizeDepth &&
                  <tr>
                    <td>Djup:</td>
                    <td>{variant.sizeDepth} cm</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
          <div className="CustomerProductCard-price">
            {!isDefault && (!activeSelection.slot.advanced || !!variantConfig) &&
              <span>Pris: <FormattedPrice
                value={productPrice(
                  variant,
                  activeSelection.slot,
                  activeSelection.orderRow,
                  variantConfig,
                  activeSelection.config,
                )}
                unit={productUnit(
                  variant,
                  activeSelection.slot,
                  activeSelection.orderRow,
                  variantConfig,
                  activeSelection.config,
                )} />
              </span>
            }
          </div>
          {variant.replacement &&
            <div className="CustomerProductCard-information">
              <div>Ersatt av:</div>
              <div className="CustomerProductCard-replacement-name">
                {variant.replacement.productName} - {variant.replacement.variantName}
              </div>
            </div>
          }
          {(!variant.replacement && (product.archived || variant.archived)) &&
            <div className="CustomerProductCard-information">
              <div>Produkten har utgått</div>
            </div>
          }
        </div>
        {isDefault &&
          <div className="label CustomerProductCard-label">
            Standard
          </div>
        }
        { userRole !== DEMO &&
         <CustomerProductOrderButton
           isOrdered={isSelected}
           onSelectProduct={() => onSelectProduct(variant)}
           onRemoveProduct={() => onRemoveProduct(variant)}
           enabled={enabled && variantEnabled}
           showWarning={showWarning} />
        }
        { userRole !== DEMO && isSelected &&
          <div className="ribbon ribbon-small">
            <i className="fa fa-check-circle-o" />
          </div>
        }
      </div>
    </div>
  );
};

export default CustomerProductCard;



// WEBPACK FOOTER //
// ./src/components/CustomerProductCard/CustomerProductCard.js